import { __exports as t } from "./contact-channels155.js";
import { __require as c } from "./contact-channels156.js";
import { __require as d } from "./contact-channels157.js";
import { __require as s } from "./contact-channels158.js";
import { __require as b } from "./contact-channels159.js";
var m;
function O() {
  return m ? t : (m = 1, function(e) {
    var n = t && t.__importDefault || function(r) {
      return r && r.__esModule ? r : { default: r };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.htmlToDOM = e.domToReact = e.attributesToProps = e.Text = e.ProcessingInstruction = e.Element = e.Comment = void 0, e.default = l;
    var a = n(c());
    e.htmlToDOM = a.default;
    var f = n(d());
    e.attributesToProps = f.default;
    var o = n(s());
    e.domToReact = o.default;
    var u = /* @__PURE__ */ b();
    Object.defineProperty(e, "Comment", { enumerable: !0, get: function() {
      return u.Comment;
    } }), Object.defineProperty(e, "Element", { enumerable: !0, get: function() {
      return u.Element;
    } }), Object.defineProperty(e, "ProcessingInstruction", { enumerable: !0, get: function() {
      return u.ProcessingInstruction;
    } }), Object.defineProperty(e, "Text", { enumerable: !0, get: function() {
      return u.Text;
    } });
    var _ = { lowerCaseAttributeNames: !1 };
    function l(r, i) {
      if (typeof r != "string")
        throw new TypeError("First argument must be a string");
      return r ? (0, o.default)((0, a.default)(r, (i == null ? void 0 : i.htmlparser2) || _), i) : [];
    }
  }(t), t);
}
export {
  O as __require
};
//# sourceMappingURL=contact-channels154.js.map
